import is from 'is_js';

import { KET_EXAM_TYPE_MOCK } from './model';

export function getKetExamsPlan(state, groupId) {
  return state.get('rootReducer').get('ketExams').get('plans').get(groupId);
}

export function getKetExam(state, ketExamId) {
  return state.get('rootReducer').get('ketExams').get('exams').get(ketExamId);
}

export function getKetExamPlanByType(state, groupId, examType, mockIndex) {
  const plans = getKetExamsPlan(state, groupId);
  if (! plans || ! plans.data || plans.loading || plans.error) return undefined;
  return plans.data.find((exam) => {
    if (exam.get('examType') !== examType) return false;
    if (examType !== KET_EXAM_TYPE_MOCK) return true;
    return `${exam.get('mockIndex')}` === `${mockIndex}`;
  });
}

export function mapMarkToScale(skill, mark) {
  if (! skill || ! is.number(mark)) return undefined;
  const band = skill.markToScaleMappings.find((mapping) =>
    mapping.get('mark') === mark);
  return band ? band.get('scale') : undefined;
}

export function mapScaleToBanding(scaleBandings, scale) {
  if (! scaleBandings || ! is.number(scale)) return undefined;
  const band = scaleBandings.find((mapping) =>
    scale >= mapping.get('scaleFrom') && scale <= mapping.get('scaleTo'));
  if (! band) return undefined;
  return { grade: band.get('grade'), level: band.get('cefrLevel') };
}

export function computeOverallScore(scales) {
  const validScales = (scales || []).filter((scale) => is.number(scale));
  if (validScales.length === 0) return undefined;
  return Math.floor(validScales.reduce((sum, scale) => sum + scale, 0) / validScales.length);
}

export function isFailBanding(grade) {
  return `${grade || ''}`.toLowerCase() === 'fail';
}

export function formatGradeBanding(grade, level) {
  if (isFailBanding(grade)) return 'Fail';
  if (is.existy(grade)) return `Grade ${grade} - Level ${level}`;
  if (is.existy(level)) return `Level ${level}`;
  return '';
}



// WEBPACK FOOTER //
// ./data/KetExams/accessors.js